(() => {
  const money = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return (format || '${{amount}}').replace(/\{\{\s*amount(?:_with_comma_separator|_no_decimals|_no_decimals_with_comma_separator)?\s*\}\}/, amount);
  };

  const sectionInner = (html, selector = '.shopify-section') => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  };

  const renderCartSections = (state) => {
    if (!state || !state.sections) return;
    const sections = [
      { id: 'Cart', key: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', key: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', key: 'cart-bubble', selector: '.thb-item-count' }
    ];
    sections.forEach(({ id, key, selector }) => {
      const root = document.getElementById(id);
      const html = state.sections[key];
      if (!root || !html) return;
      const target = root.querySelector(selector) || root;
      const next = sectionInner(html, selector);
      if (next) target.innerHTML = next;
    });
    if (typeof CartDrawer !== 'undefined') new CartDrawer();
    if (typeof Cart !== 'undefined') new Cart().renderContents(state);
  };

  const openCartDrawer = () => {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    document.body.classList.add('open-cc', 'open-cart');
    drawer.classList.add('active');
    try {
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    } catch (_) {}
  };

  const init = (root) => {
    if (!root || root.dataset.wgReady === 'true') return;
    root.dataset.wgReady = 'true';

    const variantsNode = root.querySelector('[data-wg-variants]');
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) {}

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const form = root.querySelector('product-form form[action*="/cart/add"]');
    const variantInput = root.querySelector('[data-wg-variant-id]');
    const priceEl = root.querySelector('[data-wg-price]');
    const compareEl = root.querySelector('[data-wg-compare-price]');
    const addButton = root.querySelector('[data-wg-add]');
    const buyButton = root.querySelector('[data-wg-buy]');
    const selectedLabel = root.querySelector('[data-wg-selected-label]');
    const selectedKind = root.querySelector('[data-wg-selected-kind]');
    const optionButtons = [...root.querySelectorAll('[data-wg-option]')];

    const removeInjectedCheckout = () => {
      root.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons, .payment_icons_wrap, .payment-icons-wrap, [class*="secure-checkout"], [class*="secure_checkout"], [data-testid*="secure-checkout"]').forEach(element => element.remove());
      root.querySelectorAll('p, span, div').forEach(element => {
        if (element.children.length > 3) return;
        const text = (element.textContent || '').trim().replace(/\s+/g, ' ');
        if (/^secure checkout with\b/i.test(text)) {
          const parent = element.parentElement;
          if (parent && (parent.textContent || '').trim().replace(/\s+/g, ' ') === text) parent.remove();
          else element.remove();
        }
      });
    };
    removeInjectedCheckout();
    const checkoutObserver = new MutationObserver(removeInjectedCheckout);
    checkoutObserver.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => checkoutObserver.disconnect(), 10000);

    const selectedOptions = [];
    optionButtons.filter(btn => btn.classList.contains('is-active')).forEach(btn => {
      selectedOptions[Number(btn.dataset.optionIndex)] = btn.dataset.value;
    });

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      const slides = [...root.querySelectorAll('[data-wg-media]')];
      const thumbs = [...root.querySelectorAll('[data-wg-thumb]')];
      const targetIndex = slides.findIndex(slide => String(slide.dataset.mediaId) === String(mediaId));
      if (targetIndex < 0) return;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === targetIndex));
      thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === targetIndex));
      root.dataset.galleryIndex = String(targetIndex);
    };

    const currentVariant = () => {
      if (!variants.length) return null;

      // Products with only Shopify's default variant do not render option buttons.
      // In that case selectedOptions is empty while the variant still has
      // ["Default Title"] in its options array, so strict option matching
      // would incorrectly return null and mark an in-stock product unavailable.
      if (!optionButtons.length) {
        const inputVariantId = Number(variantInput?.value || 0);
        return variants.find(variant => Number(variant.id) === inputVariantId)
          || variants.find(variant => variant.available)
          || variants[0]
          || null;
      }

      return variants.find(variant => {
        if (!Array.isArray(variant.options)) return false;
        return variant.options.length === selectedOptions.length
          && variant.options.every((value, index) => selectedOptions[index] === value);
      }) || null;
    };

    let variantPurchasable = false;
    const updateOptionAvailability = () => {
      optionButtons.forEach(button => {
        const index = Number(button.dataset.optionIndex);
        const candidate = variants.find(v => Array.isArray(v.options) && v.available && v.options[index] === button.dataset.value);
        const unavailable = !candidate;
        button.disabled = unavailable;
        button.classList.toggle('is-unavailable', unavailable);
        button.setAttribute('aria-disabled', String(unavailable));
      });
    };

    const updateVariant = () => {
      const variant = currentVariant();
      variantPurchasable = Boolean(variant?.available);
      if (variantInput) variantInput.value = variant?.id || '';
      updateOptionAvailability();
      if (!variant) {
        [addButton, buyButton].forEach(btn => { if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); } });
        if (addButton) {
          const text = addButton.querySelector('[data-wg-button-text]');
          if (text) text.textContent = 'UNAVAILABLE';
        }
        if (selectedLabel) selectedLabel.textContent = selectedOptions.filter(Boolean).join(' / ');
        const activeButton = optionButtons.find(button => button.classList.contains('is-active'));
        if (selectedKind && activeButton?.dataset.kind) selectedKind.textContent = '· ' + activeButton.dataset.kind;
        return;
      }
      if (priceEl) priceEl.textContent = money(variant.price, moneyFormat);
      if (compareEl) {
        const show = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !show;
        compareEl.textContent = show ? money(variant.compare_at_price, moneyFormat) : '';
      }
      const available = variantPurchasable;
      [addButton, buyButton].forEach(btn => {
        if (!btn) return;
        btn.disabled = !available;
        btn.setAttribute('aria-disabled', String(!available));
      });
      if (addButton) addButton.querySelector('[data-wg-button-text]').textContent = available ? (addButton.dataset.availableText || 'ADD TO CART') : (addButton.dataset.soldText || 'SOLD OUT');
      if (selectedLabel) selectedLabel.textContent = selectedOptions.filter(Boolean).join(' / ');
      const activeButton = optionButtons.find(button => Number(button.dataset.optionIndex) === 0 && button.classList.contains('is-active')) || optionButtons.find(button => button.classList.contains('is-active'));
      if (selectedKind && activeButton?.dataset.kind) selectedKind.textContent = '· ' + activeButton.dataset.kind;
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) showMedia(mediaId);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (_) {}
    };

    optionButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const index = Number(btn.dataset.optionIndex);
        selectedOptions[index] = btn.dataset.value;
        optionButtons.filter(item => Number(item.dataset.optionIndex) === index).forEach(item => item.classList.toggle('is-active', item === btn));
        updateVariant();
      });
    });

    const slides = [...root.querySelectorAll('[data-wg-media]')];
    const thumbs = [...root.querySelectorAll('[data-wg-thumb]')];
    root.dataset.galleryIndex = String(Math.max(0, slides.findIndex(s => s.classList.contains('is-active'))));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      thumbs.forEach((item, i) => item.classList.toggle('is-active', i === index));
      root.dataset.galleryIndex = String(index);
    }));
    const galleryMove = (direction) => {
      if (!slides.length) return;
      let index = Number(root.dataset.galleryIndex || 0);
      index = (index + direction + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      thumbs.forEach((item, i) => item.classList.toggle('is-active', i === index));
      root.dataset.galleryIndex = String(index);
    };
    root.querySelector('[data-wg-gallery-prev]')?.addEventListener('click', () => galleryMove(-1));
    root.querySelector('[data-wg-gallery-next]')?.addEventListener('click', () => galleryMove(1));

    const infoTriggers = [...root.querySelectorAll('[data-wg-info]')];
    const infoPanel = root.querySelector('[data-wg-info-panel]');
    infoTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const wasActive = trigger.classList.contains('is-active');
        infoTriggers.forEach(item => {
          item.classList.remove('is-active');
          item.setAttribute('aria-expanded', 'false');
        });
        if (wasActive) {
          if (infoPanel) {
            infoPanel.hidden = true;
            infoPanel.textContent = '';
          }
          return;
        }
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        if (infoPanel) {
          infoPanel.textContent = trigger.dataset.description || '';
          infoPanel.hidden = false;
        }
      });
    });

    const qtyInput = root.querySelector('[data-wg-qty]');
    const qtyDisplay = root.querySelector('[data-wg-qty-display]');
    const setQty = (value) => {
      if (!qtyInput) return;
      const min = Number(qtyInput.min || 1);
      const max = qtyInput.max ? Number(qtyInput.max) : Infinity;
      const safeValue = Math.min(max, Math.max(min, Number(value || min)));
      qtyInput.value = String(safeValue);
      if (qtyDisplay) qtyDisplay.textContent = String(safeValue);
    };
    root.querySelectorAll('[data-wg-minus]').forEach(btn => btn.addEventListener('click', () => {
      setQty(Number(qtyInput?.value || 1) - Number(qtyInput?.step || 1));
    }));
    root.querySelectorAll('[data-wg-plus]').forEach(btn => btn.addEventListener('click', () => {
      setQty(Number(qtyInput?.value || 1) + Number(qtyInput?.step || 1));
    }));
    setQty(qtyInput?.value || 1);
/*
    const upsell = root.querySelector('[data-wg-upsell]');
    const upsellInput = root.querySelector('[data-wg-upsell-input]');
    const CARBON_X_VARIANT_ID = 42280613970093;
    const upsellVariantId = Number(upsell?.dataset.variantId || CARBON_X_VARIANT_ID);

    const syncUpsell = () => {
      const selected = Boolean(upsellInput?.checked);
      upsell?.classList.toggle('is-checked', selected);
      upsell?.setAttribute('aria-checked', String(selected));

      form?.querySelector('[data-wg-upsell-form-fields]')?.remove();
      if (selected && form && Number.isFinite(upsellVariantId) && upsellVariantId > 0) {
        const fields = document.createElement('div');
        fields.hidden = true;
        fields.dataset.wgUpsellFormFields = '';
        fields.innerHTML = `<input type="hidden" name="items[1][id]" value="${upsellVariantId}"><input type="hidden" name="items[1][quantity]" value="1">`;
        form.appendChild(fields);
      }
    };

    upsellInput?.addEventListener('change', syncUpsell);
    syncUpsell();

    */
const upsells = [...root.querySelectorAll('[data-wg-upsell]')];

const syncUpsell = () => {
  // Update the visual state of each upsell card
  upsells.forEach(upsell => {
    const input = upsell.querySelector('[data-wg-upsell-input]');
    const selected = Boolean(input?.checked);

    upsell.classList.toggle('is-checked', selected);
    upsell.setAttribute('aria-checked', String(selected));
  });

  // Remove previously generated upsell fields
  form?.querySelector('[data-wg-upsell-form-fields]')?.remove();

  if (!form) return;

  // Get all selected Carbon-X variants
  const selectedUpsells = upsells.filter(upsell => {
    const input = upsell.querySelector('[data-wg-upsell-input]');
    const variantId = Number(upsell.dataset.variantId);

    return input?.checked &&
      Number.isFinite(variantId) &&
      variantId > 0;
  });

  if (!selectedUpsells.length) return;

  // Generate cart fields for all selected variants
  const fields = document.createElement('div');

  fields.hidden = true;
  fields.dataset.wgUpsellFormFields = '';

  fields.innerHTML = selectedUpsells.map((upsell, index) => {
    const variantId = Number(upsell.dataset.variantId);
    const itemIndex = index + 1;

    return `
      <input
        type="hidden"
        name="items[${itemIndex}][id]"
        value="${variantId}"
      >
      <input
        type="hidden"
        name="items[${itemIndex}][quantity]"
        value="1"
      >
    `;
  }).join('');

  form.appendChild(fields);
};

// Listen for changes on BOTH upsell checkboxes
upsells.forEach(upsell => {
  const input = upsell.querySelector('[data-wg-upsell-input]');
  input?.addEventListener('change', syncUpsell);
});

syncUpsell();

    const setLoading = (state) => {
      root.classList.toggle('wg-loading', state);
      [addButton, buyButton].forEach(btn => { if (btn) btn.disabled = Boolean(state) || !variantPurchasable; });
    };

    // Add to Cart is handled by Reformation's original product-form class.
    // This preserves the native form payload and every app/market field.
    buyButton?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const variant = currentVariant();
      if (!form || !variant?.available) return;

      const errorEl = root.querySelector('[data-wg-error]');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      let returnInput = form.querySelector('input[name="return_to"][data-wg-checkout-return]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.dataset.wgCheckoutReturn = '';
        form.appendChild(returnInput);
      }
      returnInput.value = `${window.Shopify?.routes?.root || '/'}checkout`;
      setLoading(true);
      HTMLFormElement.prototype.submit.call(form);
    });

    root.querySelectorAll('[data-wg-scroll-buybox]').forEach(btn => btn.addEventListener('click', event => {
      event.preventDefault();
      root.querySelector('[data-wg-buybox]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    root.querySelectorAll('video[data-src]').forEach(video => {
      if (!video.src && video.dataset.src) video.src = video.dataset.src;
      if (video.hasAttribute('autoplay')) {
        video.muted = true;
        video.defaultMuted = true;
        const promise = video.play?.();
        if (promise?.catch) promise.catch(() => {});
      }
    });

    if (window.lucide?.createIcons) window.lucide.createIcons({ attrs: { 'stroke-width': 1.8 } });
    updateVariant();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-wg-maze-section]')) init(scope);
    scope.querySelectorAll?.('[data-wg-maze-section]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
